// @flow
import React, { Component } from 'react';
import {
  ModelListTd,
  ModelRowTr,
  SpacerTd
} from '../../../../components/ModelListStyles';
import { TableRowSpanDot } from './MerchantTransactionTableStyles';
import {
  LgDesktop,
  Desktop,
  Default,
  Tablet,
  Mobile
} from '../../../../components/Responsive';
import { type Currencies } from '../../../../utilities/types';
import { formatCurrency } from '../../../../utilities/numberFormatting';
import { type Transaction } from '..';
import { formatDate } from '../../../../utilities/misc';
type Props = {
  transaction: Transaction,
  expandedRow: number,
  expandRow: (id: number) => void,
  currencies: Currencies
};

export default class MerchantTransactionRow extends Component<Props> {
  handleClick = () => {
    this.props.expandRow(this.props.transaction.id);
  };

  statusColor = () => {
    switch (this.props.transaction.status) {
      case 'completed':
      case 'paid':
      case 'refunded':
        return 'green';
      case 'overpaid':
        return 'darkOrange';
      case 'underpaid':
        return 'orange';
      case 'cancelled':
        return 'red';
      default:
        break;
    }
  };

  renderStatusDot = () => (
    <ModelListTd>
      <TableRowSpanDot color={this.statusColor()} />
    </ModelListTd>
  );
  render() {
    const { transaction } = this.props;
    let amount = transaction.transaction_amount;
    let currency = this.props.currencies[transaction.currency];
    if (transaction.settlement_method === 'instant') {
      amount = transaction.amount_in_fiat_received;
      currency = this.props.currencies[transaction.fiat_currency];
    }
    return (
      <ModelRowTr
        onClick={this.handleClick}
        expanded={this.props.expandedRow === transaction.id}
        highlighted={this.props.expandedRow === transaction.id}
        hideborderMobile={this.props.expandedRow === transaction.id}
      >
        <SpacerTd />
        <LgDesktop>
          <ModelListTd>{transaction.transaction_id}</ModelListTd>

          <ModelListTd>{formatDate(transaction.created_at)}</ModelListTd>
        </LgDesktop>
        <ModelListTd>{transaction.merchant_name}</ModelListTd>
        <ModelListTd right>{formatCurrency(amount, currency)}</ModelListTd>
        <LgDesktop>
          <ModelListTd right>
            {formatCurrency(transaction.transaction_fee || 0, currency)}
          </ModelListTd>
        </LgDesktop>
        <Desktop>
          <ModelListTd color={this.statusColor()} capitalize>
            {transaction.status}
          </ModelListTd>
        </Desktop>
        <Tablet>{this.renderStatusDot()}</Tablet>
        <Default>
          <ModelListTd right>
            {formatCurrency(transaction.revenue_share || 0, currency)}
          </ModelListTd>
        </Default>
        <Mobile>{this.renderStatusDot()}</Mobile>
        <SpacerTd />
      </ModelRowTr>
    );
  }
}
